import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/** Mirrored arrows across a horizontal axis — the image-preview "flip vertical" control. */
const IconFlipVertical: React.FC<IconProps> = ({
  size = 18,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M3 12h18" stroke="currentColor" strokeWidth="1.6" strokeDasharray="2 2" />
    <path d="M7 9 12 4l5 5H7ZM7 15l5 5 5-5H7Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

export default IconFlipVertical;
